import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import gmapPricingTableApi from "./services/GMAP/gmapPricingTableApi";
import commonApi from "./services/common/commonApi";
import authReducer from './slice/authSlice';
import authApi from "./services/login/authApi";
import adminDashBoardApi from "./services/DashBoard/adminDashBoardApi";
import loginApi from "./services/GMAP/login";
import corporateMemberApi from "./services/corporateMembership/corporateMemberApi";
import corporateMembershipTaskListApi from "./services/CorporateMembershipTaskList/corporateMembershipTaskListApi";
import boardMemberManagementApi from "./services/boardMemberManagement/boardMemberManagementApi";
import xeroPaymentApi from "./services/XeroPayment/xeroPaymentApi";
import emailTemplateManagementApi from "./services/FieldManagement/EmailTemplateManagementApi";
import dropdownManagementApi from "./services/FieldManagement/DropdoenManagement/DropdownManagementApi";
import resourceApi from "./services/Resource/resourceApi";
import employeesApi from "./services/Employees/employeeApi";
import productAndServiceApi from "./services/productAndService/productAndServiceApi";
import crudApi from "./services/Crud/crudApi";
import selfEvalutionReviewServiceApi from "./services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import selfEvalutionServiceApi from "./services/SelfEvaluationForm/selfEvalutionServiceApi";
import certificateGroupingApi from "./services/CertificateGrouping/certificateGroupingApi";
import corporateCertificateApi from "./services/CorporateCertificate/corporateCertificateApi";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        [authApi.reducerPath]: authApi.reducer,
        [commonApi.reducerPath]: commonApi.reducer,
        [gmapPricingTableApi.reducerPath]: gmapPricingTableApi.reducer,
        [loginApi.reducerPath]: loginApi.reducer,
        [adminDashBoardApi.reducerPath]: adminDashBoardApi.reducer,
        [corporateMembershipTaskListApi.reducerPath]: corporateMembershipTaskListApi.reducer,
        [corporateMemberApi.reducerPath]:corporateMemberApi.reducer,
        [boardMemberManagementApi.reducerPath]:boardMemberManagementApi.reducer,
        [xeroPaymentApi.reducerPath]:xeroPaymentApi.reducer,
        [emailTemplateManagementApi.reducerPath]:emailTemplateManagementApi.reducer,
        [dropdownManagementApi.reducerPath]:dropdownManagementApi.reducer,
        [resourceApi.reducerPath]:resourceApi.reducer,
        [employeesApi.reducerPath]:employeesApi.reducer,
        [productAndServiceApi.reducerPath]:productAndServiceApi.reducer,
        [crudApi.reducerPath]:crudApi.reducer,
        [selfEvalutionServiceApi.reducerPath]: selfEvalutionServiceApi.reducer,
        [selfEvalutionReviewServiceApi.reducerPath]: selfEvalutionReviewServiceApi.reducer,
        [certificateGroupingApi.reducerPath]:certificateGroupingApi.reducer,
        [corporateCertificateApi.reducerPath]:corporateCertificateApi.reducer
    },

    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
        authApi.middleware,
        gmapPricingTableApi.middleware,
        commonApi.middleware,
        loginApi.middleware,
        adminDashBoardApi.middleware,
        corporateMembershipTaskListApi.middleware,
        corporateMemberApi.middleware,
        boardMemberManagementApi.middleware,
        xeroPaymentApi.middleware,
        emailTemplateManagementApi.middleware,
        dropdownManagementApi.middleware,
        resourceApi.middleware,
        employeesApi.middleware,
        productAndServiceApi.middleware,
        crudApi.middleware,
        selfEvalutionServiceApi.middleware,
        selfEvalutionReviewServiceApi.middleware,
        certificateGroupingApi.middleware,
        corporateCertificateApi.middleware
    )

})
setupListeners(store.dispatch)